import * as React from "react"
import { IconSeeker } from "@ui-seeker/core"


export default function PriceEvolutionWidgetIcon({ icon, color, backgroundColor }) {
    return <IconSeeker
        icon={icon}
        iconType="mui"
        sx={{
            color,
            backgroundColor,
            borderRadius: "50%",
            p: .5,
            width: 24,
            height: 24,
            mr: 1
        }}
    />
}